import Modal from 'bootstrap/js/src/modal';

function shareUrl() {
  let current_ort_id = JSON.parse(window.localStorage.getItem("current_city_id"));
  let url = window.location.href;

  // add the current ort by eg. 'ort=17' to url if not present
  if (url.indexOf("ort=") == -1) {
    url = url +
      ((url.indexOf("?") >= 0) ? "&" : "?") +
      `ort=${current_ort_id}`;
  }
  return url;
}

// iPadOS 13+ reports itself as "MacIntel" but supports multi-touch
function isMobileDevice() {
  return /Android|iPhone|iPad|iPod/i.test(navigator.userAgent) ||
    (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1);
}

function hideOpenModals() {
  document.querySelectorAll('.modal.show').forEach(function(el) {
    const modal = Modal.getInstance(el);
    if (modal) { modal.hide(); }
  });
}

function showShareModal(modalId) {
  const el = document.getElementById(modalId);
  if (!el) { return; }
  hideOpenModals();
  (Modal.getInstance(el) || new Modal(el)).show();
}

function handleShare(modalId) {
  // Native share sheets are only reliable on mobile devices; desktop
  // browsers (especially on Windows) get the fallback modal directly.
  if (isMobileDevice() && navigator.share) {
    navigator.share({
      title: $("h2").text(),
      text: $("h2").text(),
      url: shareUrl()
    })
    .catch(function(error) {
      // AbortError just means the user closed the native share sheet
      if (!error || error.name !== 'AbortError') { showShareModal(modalId); }
    });
  } else {
    showShareModal(modalId);
  }
}

function copyToClipboard(text) {
  if (navigator.clipboard && window.isSecureContext) {
    return navigator.clipboard.writeText(text);
  }
  // execCommand fallback for older browsers / insecure contexts
  return new Promise(function(resolve, reject) {
    const textarea = document.createElement('textarea');
    textarea.value = text;
    textarea.style.position = 'fixed';
    textarea.style.opacity = '0';
    document.body.appendChild(textarea);
    textarea.focus();
    textarea.select();
    try {
      document.execCommand('copy') ? resolve() : reject(new Error('copy failed'));
    } catch (error) {
      reject(error);
    } finally {
      document.body.removeChild(textarea);
    }
  });
}

// delegated handler bound once to document — must stay outside turbo:load
$(document).on('click', '.copy-share-link', function() {
  const item = $(this);
  const url = item.data('url') || shareUrl();
  copyToClipboard(url).then(function() {
    item.find('.copy-link-icon').addClass('d-none');
    item.find('.copy-link-done').removeClass('d-none');
    item.find('.copy-link-feedback').removeClass('invisible');
    clearTimeout(item.data('copy-feedback-timer'));
    item.data('copy-feedback-timer', setTimeout(function() {
      item.find('.copy-link-icon').removeClass('d-none');
      item.find('.copy-link-done').addClass('d-none');
      item.find('.copy-link-feedback').addClass('invisible');
    }, 2000));
  });
});

$(document).on('turbo:load', function() {
  $("#poi_share").click(function() {
    handleShare("pois-share-modal");
  });
  $(".article-share").click(function() {
    if (window.matomoTracker) { window.matomoTracker.trackEvent('App', 'share_article'); }
    handleShare("article-share-modal");
  });
  $("#verwaltung-share").click(function() {
    handleShare("verwaltung-share-modal");
  });
  $("#event-share").click(function() {
    handleShare("event-share-modal");
  });
  $("#offer-share").click(function() {
    handleShare("offer-share-modal");
  });
});
